import { render, staticRenderFns } from "./CadSetor.vue?vue&type=template&id=75824790&"
import script from "./CadSetor.vue?vue&type=script&lang=js&"
export * from "./CadSetor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports